import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MainButton from "../../components/MainButton/mainButton";
import { AppStore } from "../../redux/store";
import { useParams } from "react-router-dom";
import useCallApiAndLoad from "../../hooks/useCallApiAndLoad";
import { getDetailTransaction } from "../Investor/services/investorService";
import { fetchResponseAdapter } from "../../adapters/fetchAdapter";
import { TransactionCheckout, TransactionFastPay } from "../Investor/models/investorModel";
import Tooltip from "@mui/material/Tooltip";
import { IconCreditCard, IconTransfer } from "@tabler/icons-react";
import TransferPayment from "./components/TransferMethod/Transfermethod";
import CardMethodPayment from "./components/CardMethod/CardMethod";
import LoadingComponent from "../../components/Loading/Loading";

const UnauthenticatedPay = () => {
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState<TransactionFastPay>();
  const [payment, setPayment] = useState<string>("pay");
  const [errorCode, setErrorCode] = useState<number | null>(null);
  const [statusCode, setStatusCode] = useState<number | null>(null);
  const { country } = useSelector((store: AppStore) => store.country);
  const { transaction_id = "" } = useParams();
  const { callEndpoint } = useCallApiAndLoad();

  // do something
  const GoToMarket = () => {
    // do something
    if (typeof window !== "undefined") {
      window.open(`/${country}/venta/casas-y-apartamentos/proyectos`, "_self");
    }
  };

  useEffect(() => {
    const loadPaymentDetail = async () => {
      const paymentMethodMapper = {
        pay: "card",
        transfer: "wire_transfer",
      };
      setLoadingDetail(true);
      const { status, data } = await callEndpoint(
        getDetailTransaction(
          transaction_id,
          paymentMethodMapper[payment as keyof typeof paymentMethodMapper]
        )
      );

      setStatusCode(status);

      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setDataDetail(response?.data);

        if (response.data.is_available_card_transactions === false) {
          setPayment("transfer");
        } else if (response.data.is_available_transfer_transactions === false) {
          setPayment("pay");
        }
      } else {
        setErrorCode(data?.code ?? null);
      }

      setLoadingDetail(false);
    };
    loadPaymentDetail().catch((e) => console.error(e));
  }, [payment]);

  const methodPay = (e: any) => {
    setPayment(e.target.value);
  };

  const renderErrorMessage = () => {
    if (statusCode === 500) {
      return (
        <div className="text-center mt-20 text-red-600 text-xl font-semibold">
          Algo salió mal. Por favor, intenta más tarde.
        </div>
      );
    }

    switch (errorCode) {
      case 3101:
        return (
          <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
            <div className="container mx-auto">
              <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
                <img
                  className=" w-48 mx-auto"
                  src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                  alt=""
                />
                <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">
                  No existe un pago creado
                </h1>
                <p className=" text-center font-medium text-[#757575] ">
                  Comunicate con tú encargado de venta asignado.
                </p>
              </div>
            </div>
          </section>
        );
      case 3104:
        return (
          <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
            <div className="container mx-auto">
              <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
                <img
                  className=" w-48 mx-auto"
                  src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                  alt=""
                />
                <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">
                  El pago ya fue realizado
                </h1>
                <p className=" text-center font-medium text-[#757575] ">
                  Por si estas interesado en otros proyectos, visita nuestra
                  marketplace
                </p>
                <button
                  onClick={GoToMarket}
                  className=" py-2 px-6 bg-[#212121] text-center rounded-xl text-white mx-auto block mt-6 font-medium"
                >
                  Ver más proyectos
                </button>
              </div>
            </div>
          </section>
        );
      case 3105:
        return (
          <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
            <div className="container mx-auto">
              <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
                <img
                  className=" w-48 mx-auto"
                  src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                  alt=""
                />
                <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">
                  Este pago de dicha propiedad fue desactivado
                </h1>
                <p className=" text-center font-medium text-[#757575] ">
                  Verifica con tú encargado de venta asignado.
                </p>
              </div>
            </div>
          </section>
        );
      case 3106:
        return (
          <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
            <div className="container mx-auto">
              <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
                <img
                  className=" w-48 mx-auto"
                  src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                  alt=""
                />
                <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">
                  Este pago está siendo validado{" "}
                </h1>
                <p className=" text-center font-medium text-[#757575] ">
                  Nos comunicaremos contigo en la brevedad posible.
                </p>
              </div>
            </div>
          </section>
        );
      default:
        return (
          <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
            <div className="container mx-auto">
              <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
                <img
                  className=" w-48 mx-auto"
                  src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                  alt=""
                />
                <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">
                  Algo salió mal. Por favor, intenta más tarde.
                </h1>
                <p className=" text-center font-medium text-[#757575] ">
                  Verifica con tú encargado de venta asignado.
                </p>
              </div>
            </div>
          </section>
        );
    }
  };

  return (
    <div className="flex flex-col h-auto lg:h-screen">
      {loadingDetail ? (
        <div className=" w-full h-screen flex justify-center items-center">
          <div className="w-full">
            <LoadingComponent />
          </div>
        </div>
      ) : statusCode !== 200 || errorCode ? (
        renderErrorMessage()
      ) : (
        <div className=" flex-1">
          <div className="flex md:flex-row flex-col h-full">
            <div className="flex flex-col md:w-2/5 justify-start items-start text-flat-dark-blue-500  bg-[#D5F0E3]">
              <div className="py-10 lg:px-10 px-6 w-full">
                <h2 className="text-2xl font-semibold text-[#212121] flex justify-start items-center gap-2">
                  <img
                    className="w-10"
                    src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi-icono.svg"
                    alt=""
                  />
                  Pago rápido
                </h2>
                <h1 className="text-2xl font-semibold text-[#212121] mt-6">
                  {dataDetail?.itemInfo?.title}
                  {dataDetail?.itemInfo?.subtitle
                    ? ` | ${dataDetail?.itemInfo?.subtitle}`
                    : ""}
                </h1>

                <p className="text-3xl font-semibold text-[#212121]">
                  {dataDetail?.total}
                </p>
                <p className="text-sm font-normal text-[#757575]">
                  {dataDetail?.itemInfo?.address}
                </p>

                <div className="w-full mt-10">
                  <h2 className="text-xl text-[#212121] font-semibold">
                    Detalle de pago
                  </h2>
                  <hr className=" w-full border-[#82D3AA] mt-2" />
                  <div className="mt-4">
                    {dataDetail?.detail.map((item) =>
                      item.is_total ? (
                        <div className="w-full mb-2 text-[#616161] flex justify-between">
                          <div>
                            <span> {item.label}</span>
                            {typeof item?.description === 'string' && item.description.trim() !== '' && (
                                <Tooltip
                                    className="cursor-pointer"
                                    title={item.description}
                                    placement="top"
                                    enterTouchDelay={0}
                                    arrow
                                >
                                    <img
                                    className="w-5 h-5"
                                    src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/invest/info.svg"
                                    alt=""
                                    />
                                </Tooltip>
                                )}
                          </div>

                          <span className="text-[#212121] font-semibold">
                            {" "}
                            {item.value}
                          </span>
                        </div>
                      ) : (
                        <div className="w-full mb-2 text-[#616161] flex justify-between">
                          <div className="flex justify-between items-center gap-1">
                            <span> {item.label}</span>
                            {typeof item?.description === 'string' && item.description.trim() !== '' && (
                                <Tooltip
                                    className="cursor-pointer"
                                    title={item.description}
                                    placement="top"
                                    enterTouchDelay={0}
                                    arrow
                                >
                                    <img
                                    className="w-5 h-5"
                                    src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/invest/info.svg"
                                    alt=""
                                    />
                                </Tooltip>
                                )}
                          </div>

                          <span className="text-[#212121] font-semibold">
                            {" "}
                            {item.value}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                  <hr className=" w-full border-[#82D3AA] mt-2" />
                  <div className="mt-4 mb-2">
                    <div className="w-full bg-[#1C6D44] px-4 rounded-xl py-4 flex justify-between items-center">
                      <p className="text-white font-semibold">
                        Total a cancelar
                      </p>
                      <span className="text-white text-xl font-bold">
                        {dataDetail?.total}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white drop-shadow-none md:w-3/5 flex flex-wrap px-4 py-8 md:py-0 md:px-0">
              <div className="w-full xl:px-20 lg:py-10 px-2 py-2">
                <div className=" max-w-2xl mx-auto">
                  <h2 className="text-lg lg:text-xl text-[#212121] font-semibold">
                    {" "}
                    Método de pago
                  </h2>
                  <p className="text-xm font-normal text-[#757575]">
                    Selecciona el metodo que mas te convenga
                  </p>
                  {dataDetail?.is_available_card_transactions &&
                    dataDetail?.is_available_transfer_transactions && (
                      <div className="flex justify-start items-center mt-4 gap-4">
                        <div className="relative">
                          <input
                            type="radio"
                            name="radio"
                            id="pay"
                            value="pay"
                            checked={payment === "pay"}
                            className="hidden peer"
                            onChange={(e) => methodPay(e)}
                          />
                          <label
                            htmlFor="pay"
                            className="inline-flex items-center justify-center w-24 py-2 bg-white border-2 rounded-lg cursor-pointer group border-neutral-200/70 text-neutral-600 peer-checked:border-primary peer-checked:text-neutral-900 peer-checked:bg-blue-200/50 peer-checked:ring-2 peer-checked:ring-primary peer-checked:scale-105 transition-transform transition-shadow duration-200 hover:text-neutral-900 hover:border-neutral-300"
                          >
                            <div className="flex flex-col justify-center items-center">
                              <IconCreditCard />
                              <p className="text-sm font-normal">Tarjeta</p>
                            </div>
                          </label>
                        </div>

                        <div className="relative">
                          <input
                            type="radio"
                            name="radio"
                            id="transfer"
                            value="transfer"
                            checked={payment === "transfer"}
                            className="hidden peer"
                            onChange={(e) => methodPay(e)}
                          />
                          <label
                            htmlFor="transfer"
                            className="inline-flex items-center justify-center w-24 py-2 bg-white border-2 rounded-lg cursor-pointer group border-neutral-200/70 text-neutral-600 peer-checked:border-primary peer-checked:text-neutral-900 peer-checked:bg-blue-200/50 peer-checked:ring-2 peer-checked:ring-primary peer-checked:scale-105 transition-transform transition-shadow duration-200 hover:text-neutral-900 hover:border-neutral-300"
                          >
                            <div className="flex flex-col justify-center items-center">
                              <IconTransfer />
                              <p className="text-sm font-normal">
                                Transferencia
                              </p>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  <p className=" text-sm font-normal text-[#212121] mt-4">
                    <strong>Importante: </strong>El método de pago (tarjeta o
                    cuenta bancaria) debe estar a nombre del titular de la
                    compra.
                  </p>
                  <div className="mt-4">
                    {payment !== "pay" && (
                      <TransferPayment
                      typeTransfer={
                        dataDetail?.itemInfo?.type === "pre_sale"
                          ? "pre-sales"
                          : dataDetail?.itemInfo?.type === "sale"
                          ? "sale"
                          : "rent"
                      }
                        contract_id={transaction_id}
                        transaction_detail_id={transaction_id}
                        projectId={
                          dataDetail?.itemInfo?.id as string
                        }
                        realm="landlord"
                      />
                    )}

                    {payment === "pay" && (
                      <CardMethodPayment
                        contractId={transaction_id}
                        transactionId={transaction_id}
                        name="Pago de reserva"
                        btnText="Pagar"
                        realm="landlord"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnauthenticatedPay;
